
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import auth from '../../../config/app-specific-config/auth';
import { MANAGE_SAA_QUERY_FAILURE, MANAGE_SAA_QUERY_REQUEST, MANAGE_SAA_QUERY_SUCCESS } from './saa-internal-portal-action-types';


export const manageInternalPortalEventSuccess = (response, dsrId) => {
	return {
		type: MANAGE_SAA_QUERY_SUCCESS,
		payload: { data: response.data, id: dsrId }
	};
};

export const manageInternalPortalEventFailure = (error) => {
	return {
		type: MANAGE_SAA_QUERY_FAILURE,
		error
	};
};

export const manageInternalPortalEventRequest = () => {
	return {
		type: MANAGE_SAA_QUERY_REQUEST
	};
};

export function manageInternalPortalEvent(ipMetadata) {
	return async (dispatch) => {

		dispatch(manageInternalPortalEventRequest());
		try {
			const url = `/intport/manage`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				ipMetadata,
				{ headers }
			);

			dispatch(manageInternalPortalEventSuccess(response.data))
		} catch (error) {
			dispatch(manageInternalPortalEventFailure(error));
		}
	};
}
